import { render, staticRenderFns } from "./VirtualMenu.vue?vue&type=template&id=7859bb5f&"
import script from "./VirtualMenu.vue?vue&type=script&lang=js&"
export * from "./VirtualMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports